const AUTH_DATA = "__session";

export { AUTH_DATA };
